export function formatarDataSemTimezone(data: string, removeYear = false, newFormat = false): string {
  if (!data) return " - ";

  if (!data.includes("T")) {
    const [ano, mes, dia] = data.split("-");
    if (removeYear) return `${dia}/${mes}`;
    if (newFormat) return `${dia}/${mes}/${ano.slice(2)}`;
    return `${dia}/${mes}/${ano}`;
  }

  const [dataParte, horaParte] = data.split("T");

  const [ano, mes, dia] = dataParte.split("-");
  const [hora] = horaParte.split(".");
  
  const newHour = hora.split(":");

  return `${dia}/${mes}/${ano} ${newHour[0]}:${newHour[1]}`;
}

export function hexToRgb(hex: string) {
  const sanitized = hex.replace("#", "");

  const r = parseInt(sanitized.substring(0, 2), 16);
  const g = parseInt(sanitized.substring(2, 4), 16);
  const b = parseInt(sanitized.substring(4, 6), 16);

  return { r, g, b };
}

export function hexToRgba(hex: string, alpha = 1) {
  const { r, g, b } = hexToRgb(hex);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

export function limitarCaracteres(texto: string, limite: number, optional: boolean = false): string {
  if (!texto) return "-";
  if (texto.length > limite) {
    if (optional) return texto.substring(0, limite);
    return `${texto.substring(0, limite)}...`;
  }
  return texto;
}

export function darkenHex(color: string, amount = 0.15) {
  if (!color) return "";
  let c = color.replace("#", "");

  if (c.length === 3) {
    c = c.split("").map(x => x + x).join("");
  }

  const num = parseInt(c, 16);

  let r = (num >> 16) & 255;
  let g = (num >> 8) & 255;
  let b = num & 255;

  r = Math.max(0, Math.floor(r * (1 - amount)));
  g = Math.max(0, Math.floor(g * (1 - amount)));
  b = Math.max(0, Math.floor(b * (1 - amount)));

  return `rgb(${r}, ${g}, ${b})`;
}

export const STATUS_DISABLED = ["Atrasada", "AguardandoAtivacao", "Cancelada", "ExecutadaParcialmente", "Executada"];

 export const MOTIVOS = {
   climatico: "Climático",
   decisaoagronomica: "Decisão Agronômica",
   problemaoperacional: "Problema Operacional",
   capacidadeoperacional: "Capacidade Operacional",
 };

 export function getMotivo(value: string) {
  if (!value) return undefined;
  const key = value?.toLowerCase() as keyof typeof MOTIVOS;
  return MOTIVOS[key];
}

   export const getDataOrdenacao = (item: any) => {
      const data =
        item.status === "Cancelada" && item.reagendamentoDataAtualizacao
          ? item.reagendamentoDataAtualizacao
          : item.dataCriacao;

      return new Date(data).getTime();
    };